import { render, staticRenderFns } from "./MedicalRecordsPanel.vue?vue&type=template&id=2b31a88e"
import script from "./MedicalRecordsPanel.vue?vue&type=script&lang=js"
export * from "./MedicalRecordsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports